export default "__VITE_ASSET__B2ZC8aT0__"